import { createContext } from 'react';
import { CardType } from 'api/card';

type Props = {
  supertypeList: CardType[],
  typeList: CardType[],
  subtypeList: CardType[],
};

export const CardTypesContext = createContext<Props>({
  supertypeList: [],
  typeList: [],
  subtypeList: [],
});
